  var sw = parseFloat($('.camera-selector option:selected').attr('data-sw'));
  var sh = parseFloat($('.camera-selector option:selected').attr('data-sh'));
  var coc = parseFloat($('.camera-selector option:selected').attr('data-coc'));
  var lensType = $('.lens-type-selector option:selected').attr('data-type');
  var sensorCF = parseFloat($('.camera-selector option:selected').attr('data-cf'));

  $('.camera-selector').on('change', function(){
    sw = parseFloat($(this).find('option:selected').attr('data-sw'));
    sh = parseFloat($(this).find('option:selected').attr('data-sh'));
    coc = parseFloat($(this).find('option:selected').attr('data-coc'));
    sensorCF = parseFloat($(this).find('option:selected').attr('data-cf'));
  });

  $('.lens-type-selector').on('change', function(){
    lensType = $(this).find('option:selected').attr('data-type');
  });

  $('.calc-lof').on('click', function(){
    var _this = this;
    checkForEmptyFields(_this);
    var findGroup = $(this).parents('.calc-group-container:eq(0)'),
        d = parseFloat(findGroup.find('.distance').val()),
        hfov = parseFloat(findGroup.find('.hfov').val()),
        vfov = parseFloat(findGroup.find('.vfov').val()),
        aperture = parseFloat($('.f-stop').val()),
        hlofValue = lenseFocalLengthHorizontal(sw, d, hfov),
        vlofValue = lenseFocalLengthVertical(sw, d, vfov);
        hfdin = null,
        hfdc = null,
        cfValue = null,
        hfovValue = null,
        vfovValue = null;
    if(hlofValue){
      findGroup.find('[name="hlof"]').val(hlofValue);
      hfdin = hyperFocalDistanceInches(hlofValue, aperture, coc);
      hfdc = hyperFocalDistanceCm(hlofValue, aperture, coc);
      cfValue = cropFactor(hlofValue, sensorCF);
      hfovValue = horizontalFieldOfView(sw, hlofValue);
      $('.crop-factor').val(cfValue);
      $('.hyperfocal-in').val(hfdin);
      $('.hyperfocal-cm').val(hfdc);
      $('.horizontal-field-of-view').val(hfovValue);
      $('.horizontal-field-of-view-25').val(roundToTwo(hfovValue*0.75));
      $('.horizontal-field-of-view-50').val(roundToTwo(hfovValue*0.50));
      $('.vertical-field-of-view').val('');
      $('.vertical-field-of-view-25').val('');
      $('.vertical-field-of-view-50').val('');
    }
    if(vlofValue){
      findGroup.find('[name="vlof"]').val(vlofValue);
      vfovValue = verticalFieldOfView(sh, vlofValue);
      hfdin = hyperFocalDistanceInches(vlofValue, aperture, coc),
      hfdc = hyperFocalDistanceCm(vlofValue, aperture, coc);
      cfValue = cropFactor(vlofValue, sensorCF);
      $('.crop-factor').val(cfValue);
      $('.hyperfocal-in').val(hfdin);
      $('.hyperfocal-cm').val(hfdc);
      $('.vertical-field-of-view').val(vfovValue);
      $('.vertical-field-of-view-25').val(roundToTwo(vfovValue*0.75));
      $('.vertical-field-of-view-50').val(roundToTwo(vfovValue*0.50));
      $('.horizontal-field-of-view').val('');
      $('.horizontal-field-of-view-25').val('');
      $('.horizontal-field-of-view-50').val('');
    }
  });

  $('.calc-fov').on('click', function(){
    var _this = this;
    checkForEmptyFields(_this);
    var findGroup = $(this).parents('.calc-group-container:eq(0)'),
        aperture = parseFloat($('.f-stop').val()),
        f = parseFloat(findGroup.find('.lof').val()),
        hfovValue = horizontalFieldOfView(sw, f),
        vfovValue = verticalFieldOfView(sh, f),
        hfdin = hyperFocalDistanceInches(f, aperture, coc),
        hfdc = hyperFocalDistanceCm(f, aperture, coc),
        cfValue = cropFactor(f, sensorCF);
    if(f){
      findGroup.find('[name="hfov"]').val(hfovValue);
      findGroup.find('[name="vfov"]').val(vfovValue);
    }
    $('.crop-factor').val(cfValue);
    $('.horizontal-field-of-view').val(hfovValue);
    $('.vertical-field-of-view').val(vfovValue);
    $('.horizontal-field-of-view-25').val(roundToTwo(hfovValue*0.75));
    $('.vertical-field-of-view-25').val(roundToTwo(vfovValue*0.75));
    $('.horizontal-field-of-view-50').val(roundToTwo(hfovValue*0.50));
    $('.vertical-field-of-view-50').val(roundToTwo(vfovValue*0.50));
    $('.hyperfocal-in').val(hfdin);
    $('.hyperfocal-cm').val(hfdc);
  });

  $('.calc-distance').on('click', function(){
    var _this = this;
    checkForEmptyFields(_this);
    var findGroup = $(this).parents('.calc-group-container:eq(0)'),
        hfov = parseFloat(findGroup.find('.hfov').val()),
        vfov = parseFloat(findGroup.find('.vfov').val()),
        f = parseFloat(findGroup.find('.lof').val()),
        hfovValue = horizontalFieldOfView(sw, f),
        vfovValue = verticalFieldOfView(sh, f),
        aperture = parseFloat($('.f-stop').val()),
        hfdin = hyperFocalDistanceInches(f, aperture, coc),
        hfdc = hyperFocalDistanceCm(f, aperture, coc),
        distanceValueWidth = distanceWidth(f, hfov, sw),
        distanceValueHeight = distanceHeight(f, vfov, sh),
        cfValue = cropFactor(f, sensorCF);
    if(distanceValueWidth){
      findGroup.find('.distance-width').val(distanceValueWidth);
    }
    if(distanceValueHeight){
      findGroup.find('.distance-height').val(distanceValueHeight);
    }
    $('.crop-factor').val(cfValue);
    $('.hyperfocal-in').val(hfdin);
    $('.hyperfocal-cm').val(hfdc);
    $('.horizontal-field-of-view').val(hfovValue);
    $('.vertical-field-of-view').val(vfovValue);
    $('.horizontal-field-of-view-25').val(roundToTwo(hfovValue*0.75));
    $('.vertical-field-of-view-25').val(roundToTwo(vfovValue*0.75));
    $('.horizontal-field-of-view-50').val(roundToTwo(hfovValue*0.50));
    $('.vertical-field-of-view-50').val(roundToTwo(vfovValue*0.50));
  });

  $('.calc-container [type="text"]').on("keypress", function(event) {
    var englishAlphabetDigitsAndWhiteSpace = /[0-9.]/g;
    var key = String.fromCharCode(event.which);
    if (event.keyCode == 8 || event.keyCode == 37 || event.keyCode == 39 || englishAlphabetDigitsAndWhiteSpace.test(key)) {
      return true;
    }
    return false;
  });
  $('.calc-container [type="text"]').on("paste",function(e){
    e.preventDefault();
  });

  $('.switch-checkbox').on('change', function(){
    if($(this).parents('.calc-group-container').find('.switch-checkbox').is(':checked')){
      $(this).parents('.calc-group-container').find('.hfov-field').hide();
      $(this).parents('.calc-group-container').find('.vfov-field').show();
      $(this).parents('.calc-group-container').find('.showing-result').html('VFOV');
    }
    else{
      $('.hfov-field').show();
      $('.vfov-field').hide();
      $('.showing-result').html('HFOV');
    }
  });

  $('[type="text"]').on('keyup', function(event){
    if(event.which === 13){
      $(this).parents('.calc-group-container').find('[type="button"]').trigger('click');
    }
  });

  function checkForEmptyFields(_this){
    $.each($(_this).parent().find('[type="text"]'), function(){
      if(!$(this).val()){
        $(this).css('background', 'rgba(255, 0, 0, .25)');
      }
      else{
        $(this).css('background', '#fff');
      }
    });
  }

  function distanceWidth(f, hfov, sh){
    var d = (f*hfov)/sh,
        dRounded = roundToTwo(d);
    return dRounded;
  }

  function distanceHeight(f, vfov, sw){
    var d = (f*vfov)/sw,
        dRounded = roundToTwo(d);
    return dRounded;
  }

  function horizontalFieldOfView(sw, f){
    var multiplier = lensType === 'rect' ? multiplier = 2 : multiplier = 4;
    var hfov = toDegrees(multiplier*Math.tanh(sw/(f*multiplier))).toString().match(/^\d+(?:\.\d{0,2})?/)
    return hfov;
  }

  function verticalFieldOfView(sh, f){
    var multiplier = lensType === 'rect' ? multiplier = 2 : multiplier = 4;
    var vfov = toDegrees(multiplier*Math.tanh(sh/(f*multiplier))).toString().match(/^\d+(?:\.\d{0,2})?/)
    return vfov;
  }

  function cropFactor(f, sensorCF){
    var cf =  f*sensorCF,
        cfRounded = roundToTwo(cf);
    return cfRounded;
  }

  function lenseFocalLengthHorizontal(sw, d, hfov){
    var f = (sw*d)/hfov,
        fRounded = roundToTwo(f);
    return fRounded;
  }

  function lenseFocalLengthVertical(sw, d, vfov){
    var f = (sh*d)/vfov,
        fRounded = roundToTwo(f);
    return fRounded;
  }

  function hyperFocalDistanceInches(fl, a, c){
    console.log('(((' + fl + '*' + fl + ')/(' + a +'*' + c +'))+'+fl+')*0.0393701');
    var hfdi = (((fl*fl)/(a*c))+fl)*0.0393701,
        hfdiRounded = roundToTwo(hfdi);
        console.log(hfdi, 'hfdi');
    return hfdiRounded;
  }

  function hyperFocalDistanceCm(fl, a, c){
    var hfdcm = (((fl*fl)/(a*c))+fl)/10,
        hfdcmRounded = roundToTwo(hfdcm);
    return hfdcmRounded;
  }

  function toDegrees(angle) {
    return angle * (180 / Math.PI);
  }

  function roundToTwo(num) {
      return +(Math.round(num + "e+2")  + "e-2");
  }